import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { AnyRecord } from '../../utils';

import { showPrompt as showPromptAction, addModalProps } from './slice';
import { PromptPropsWithParams, UseCustomProps } from './PromptProvider.types';

const typeRegistry = new Set<string>();

export function registerType(type: string) {
    if (!typeRegistry.has(type)) {
        typeRegistry.add(type);
    }
}

export const useCustomProps: UseCustomProps = props => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(addModalProps(props));
    }, [props, dispatch]);
};

export function usePrompt() {
    const dispatch = useDispatch();

    const showPrompt = useCallback(
        <Params extends AnyRecord>(config: PromptPropsWithParams<Params>) => {
            if (config.type && !typeRegistry.has(config.type)) {
                throw Error(`
                    \n\rYou called prompt with { type: '${config.type}' }, 
                    \n\rbut forgot to add <PromptProvider type="${config.type}" />
                `);
            }

            return new Promise<boolean>(resolve => {
                dispatch(showPromptAction({ config, resolve }));
            });
        },

        [dispatch],
    );

    return { showPrompt };
}
